
module.exports =  require('./lib/');



//////////////////
// WEBPACK FOOTER
// ./modules/socketapilegacy/~/engine.io-client/index.js
// module id = 800
// module chunks = 0